module.exports = __webpack_public_path__ + "img/70100011.e9ac024d.png";